module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_9005.8cf817de.png";